import React, { useEffect, useState } from "react";
import { handleError } from "../../utils/functions";
import axiosInstance from "../../config/axios.config";
import { toast } from "react-toastify";
import ShopCard from "./ShopCard";
import ShopFilters from "./ShopFilters";
import Loading from "./Loading";
import Pagination from "./Pagination";

const ProductsSection = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    name: "",
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 1,
  });

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance({
          method: "GET",
          url: "/seller",
          params: { ...filters, page: pagination.currentPage },
        });
        if (!data.error) {
          setData(data.data);
          setPagination(data.pagination);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    };
    getData();
  }, [filters, pagination.currentPage]);

  return (
    <section className="productListingSection">
      <div className="container">
        <div className="row">
          <ShopFilters setFilters={setFilters} filters={filters} />
          <div className="col-md-12">
            <div className="row">
              {isLoading ? <Loading /> : data.map((item) => <ShopCard item={item} key={item.slug} />)}
            </div>
            <div>
              <Pagination
                totalPages={pagination.totalPages}
                currentPage={pagination.currentPage}
                handlePageChange={(value) => setPagination((prev) => ({ ...prev, currentPage: value }))}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
